import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constants/route";
import { ICityInput } from "models/city";
import createCityValidator from "validators/createCity.validator";
import { createCityApi } from "api/city";

export default function useCreateCity() {
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit } = useForm<ICityInput>({
    resolver: yupResolver(createCityValidator),
  });

  const onSubmit = async (input: ICityInput) => {
    setLoading(true);
    const { data, error } = await createCityApi(input);
    if (data) {
      showSuccess("City created Successfully");
      navigate(RouteName.CITY, { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading(false);
  };

  return { handleSubmit, onSubmit, control, loading };
}
